import { render, staticRenderFns } from "./DashBigNumbers.vue?vue&type=template&id=b46c89fa"
import script from "./DashBigNumbers.vue?vue&type=script&lang=js"
export * from "./DashBigNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports